import { Component, OnDestroy, OnInit } from '@angular/core';
import { NeighborhoodService } from '../../../services/neighborhood.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../services/auth.service';
import { NeighborhoodModalComponent } from '../../../components/neighborhood-modal/neighborhood-modal.component';
import { Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'app-neighborhoods-page',
  templateUrl: './neighborhoods-page.component.html',
  styleUrl: './neighborhoods-page.component.scss'
})
export class NeighborhoodsPageComponent implements OnInit, OnDestroy {

  // Suscripcion al par (usuario, colonias) que decide la redireccion automatica.
  // Se guarda para poder darla de baja en ngOnDestroy.
  public subscriptionRedirect?: Subscription;

  constructor(
    public authService: AuthService,
    public neighborhoodService: NeighborhoodService,
    private modalService: NgbModal,
    private router: Router
  ) {

  }

  ngOnInit(): void {

    // AuthService.getUser() y NeighborhoodService.getAll() arrancan en paralelo
    // desde los constructores de sus respectivos servicios y no hay ninguna
    // garantia de orden entre ellos: la lista de colonias puede estar lista con
    // currentUser todavia en undefined, o al reves. Por eso NO se lee
    // authService.currentUser?.profile de forma sincrona aqui — seria una
    // condicion de carrera, y equivocarse en el perfil significa encerrar a un
    // sudo en una sola colonia.
    //
    // Ambos son ReplaySubject(1), asi que replayean su ultimo valor al
    // suscriptor tardio, y combineLatest solo emite cuando los dos ya llegaron.
    this.subscriptionRedirect = combineLatest([
      this.authService.subCurrentUser,
      this.neighborhoodService.subNeighborhoods
    ]).subscribe(
      ([currentUser, neighborhoods]) => {

        // Se redirige solo si el usuario tiene exactamente una colonia Y NO es
        // sudo.
        //
        // El perfil NO es opcional en esta condicion: el boton "Agregar
        // condominio" de este listado solo lo ve un sudo
        // (neighborhoods-page.component.html). Si se redirigiera a un sudo que
        // hoy tiene una sola colonia, se quedaria sin ninguna forma de crear la
        // segunda: quedaria encerrado dentro de su unica colonia. No simplificar
        // esta condicion quitando el perfil.
        //
        // Esta condicion es la inversa exacta de la de main-header.component.html
        // (`neighborhoods.length > 1 || profile === 'sudo'`), que decide si se
        // muestra el item "Colonias" del dropdown. Si alguien cambia una, tiene
        // que cambiar la otra para que sigan siendo coherentes.
        if (neighborhoods.length === 1 && currentUser.profile !== 'sudo') {

          const neighborhood = neighborhoods[0];

          // replaceUrl: true es obligatorio. Sin el, este listado queda como paso
          // del historial: el usuario entra a su colonia, presiona "atras",
          // regresa al listado, el listado lo vuelve a redirigir hacia adelante y
          // queda atrapado en un bucle del que no puede salir con el boton atras.
          // Reemplazando la URL, el listado nunca llega a existir en el historial.
          this.router.navigate(
            ['/neighborhoods', neighborhood.neighborhoodId],
            { replaceUrl: true }
          );

        }

      }
    );

  }

  ngOnDestroy(): void {
    this.subscriptionRedirect?.unsubscribe();
  }

  open() {
    const modalRef = this.modalService.open(
      NeighborhoodModalComponent, 
      { 
        size: 'lg' 
      }
    );
  }

}
